<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import { authFackMethods } from '@/state/helpers';
import { email, required } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'User Profile',
		meta: [
			{
				name: 'User Profile',
			},
		],
	},
	components: {},
	props: ['userId', 'userTypeId', 'isMentor', 'contactInfoForm'],
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			showSSN: false,
			isKnowApplicant: '',
			cooperation: '',
			signatureOptions: [
				{ value: 'yes', text: 'Yes' },
				{ value: 'no', text: 'No' },
			],
			options: [
				{ value: 'yes', text: 'Yes' },
				{ value: 'no', text: 'No' },
				{ value: 'unsure', text: 'Unsure' },
			],
			status: [
				{ value: '1', text: 'New' },
				{ value: '2', text: 'Input Received' },
				{ value: '3', text: 'Check Completed' },
			],
			questionForm: {
				submit_application: '',
				driver_license: '',
				driving_violations: '',
				treatment: '',
				arrested: '',
				convicted: '',
				refrain: '',
				hear_about: '',
				user_type_id: '',
			},
			beforeSubmittedApplication: false,
			license: false,
			drivingViolations: false,
			drugPrescription: false,
			involveInAlcohol: false,
			convictedCriminal: false,
			refrainTobacco: false,
			typeSubmit: false,
			backgroundCheckForm: {
				user_id: null,
				ssn: null,
				ssn_remove: false,
				driver_license_number: null,
				driver_license_number_remove: false,
				signature_provided: null,
				date_signed: null,
				description: null,
				user_type_id: '',
				driver_license_state: '',
				previous_residence: [
					{
						previous_state: null,
						previous_city: null,
					},
				],
			},
			faithForm: {
				attend_worship: '',
				location: '',
				city: '',
				state: '',
				faith_involvement: '',
				faith_journey: '',
				driver_license_number: '',
				user_type_id: '',
				user_id: null,
			},
			referencesForm: {
				user_id: '',
				user_type_id: '',
				status: '',
				name: '',
				telephone: '',
				email: '',
				relationship: '',
				token: '',
				organization: '',
				title: '',
				date: '',
				year_applicant: '',
				applicant: '',
				strenths: '',
				weaknesses: '',
				adults_adolescents: '',
				professional_boundaries: '',
				spiritual_maturity: '',
				cooperation: null,
				initiative: null,
				reliability: null,
				maturity: null,
				leadership: null,
				listener: null,
				congruent: null,
				recommendation: null,
				adults_adolescents_text: '',
				professional_boundaries_text: '',
				spiritual_maturity_text: '',
			},
			employmentForm: {
				employer: '',
				city: '',
				state: '',
				user_type_id: '',
				user_id: null,
			},
			additionalDetailsForm: {
				adult_teen_challenge: '',
				hobbies: '',
				skills: '',
				language: '',
				education: '',
				occupation: '',
				employment_experience: '',
				user_type_id: '',
				working_city: '',
				additional_info: '',
				hear_about: '',
			},
			opportunitiesForm: {
				role_ids: [],
				comment: '',
				is_mentor: '',
				user_type_id: '',
			},
			selectedRoleIds: [],
			categories: [],
			isSendingCharacterReference: false,
			isDeletingCharacterReference: false,
			isUpdatingCharacterReference: false,
			isRegeneratingReferenceToken: false,
			isCreatingCharacterReference: false,
		};
	},
	validations: {
		referencesForm: {
			status: { required },
			token: { required },
			name: { required },
			email: { required, email },
		},
	},
	mounted() {
		if (this.userTypeId !== 4 || (this.userTypeId == 4 && this.contactInfoForm.is_upgraded == true)) {
			this.getBackgroundDetails();
		}
		this.getQuestions();
		this.getFaith();
		this.getReferences();
		this.getAdditionalDetails();
		this.getCategories();
		this.getOpportunities();
	},
	methods: {
		...authFackMethods,
		// Getting Current User Questions
		getQuestions() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			var userType = this.userTypeId;
			if (token) {
				axios
					.get('user/questions/' + this.userId + '?user_type_id=' + userType, config)
					.then((res) => {
						if (res.status == 200) {
							this.questionForm = res.data.response;
							if (this.questionForm.submit_application) {
								this.beforeSubmittedApplication = true;
							}
							if (this.questionForm.driver_license) {
								this.license = true;
							}
							if (this.questionForm.driving_violations) {
								this.drivingViolations = true;
							}
							if (this.questionForm.treatment) {
								this.drugPrescription = true;
							}
							if (this.questionForm.convicted) {
								this.convictedCriminal = true;
							}
							if (this.questionForm.arrested) {
								this.involveInAlcohol = true;
							}
							if (this.questionForm.refrain) {
								this.refrainTobacco = true;
							}
						}
					})
					.catch((err) => {
						console.log(err?.response?.data?.error?.message);
						if (err.response.status == 401) {
							this.logout();
						}
					});
			}
		},

		updateQuestion() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			};
			if (token) {
				if (this.beforeSubmittedApplication == false) {
					this.questionForm.submit_application = '';
				}
				if (this.convictedCriminal == false) {
					this.questionForm.convicted = '';
				}
				if (this.drugPrescription == false) {
					this.questionForm.treatment = '';
				}
				if (this.involveInAlcohol == false) {
					this.questionForm.arrested = '';
				}

				this.questionForm.user_type_id = this.userTypeId;
				axios
					.post('user/questions', this.questionForm, config)
					.then((res) => {
						this.questionForm = res.data.response;
						if (res.status == 200) {
							Swal.fire({
								title: 'Success!',
								text: 'Questions updated successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.getQuestions();
						}
					})
					.catch((err) => {
						if (err.response) {
							this.errors = err.response.data.error.message;
						}
					});
			}
		},

		// Getting Current User Background Details
		getBackgroundDetails() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			var userType = this.userTypeId;
			if (token) {
				axios
					.get('user/backgroundDetails/' + this.userId + '?user_type_id=' + userType, config)
					.then((res) => {
						if (res.status == 200) {
							this.backgroundCheckForm = res.data.response;
							this.backgroundCheckForm.ssn_remove = false;
							this.backgroundCheckForm.driver_license_number_remove = false;
							this.backgroundCheckForm.date_signed = moment(res.data.response.date_signed, 'YYYY-MM-DD').format('YYYY-MM-DD');
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		updateBackgroundDetails() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			};
			if (token) {
				this.backgroundCheckForm.user_type_id = this.userTypeId;
				this.backgroundCheckForm.user_id = this.userId;
				axios
					.post('user/backgroundDetails', this.backgroundCheckForm, config)
					.then((res) => {
						if (res.status == 200) {
							Swal.fire({
								title: 'Success!',
								text: 'Background Check updated successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.getBackgroundDetails();
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		addResidence() {
			this.backgroundCheckForm.previous_residence.push({
				previous_state: '',
				previous_city: '',
			});
		},

		deleteResidence(index) {
			this.backgroundCheckForm.previous_residence.splice(index, 1);
		},

		// Getting Current User Faith Details
		getFaith() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('user/faith/' + this.userId + '?user_type_id=' + this.userTypeId, config)
					.then((res) => {
						if (res.status == 200) {
							this.faithForm = res.data.response;
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		updateFaith() {
			// if (this.faithForm.attend_worship == 0) {
			//   this.typeSubmit = false;
			// }
			// stop here if form is invalid
			// else {
			this.typeSubmit = true;
			// this.$v.$touch();
			// if (!this.$v.faithForm.$invalid) {
			this.saveFaith();
			// }
			// }
		},
		saveFaith() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			};
			if (token) {
				this.faithForm.user_type_id = this.userTypeId;
				this.faithForm.user_id = this.userId;
				axios
					.post('user/faith', this.faithForm, config)
					.then((res) => {
						if (res.status == 200) {
							Swal.fire({
								title: 'Success!',
								text: 'Questions updated successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.getFaith();
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		// Getting Current User References
		getReferences() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('user/references/' + this.userId + '?user_type_id=' + this.userTypeId, config)
					.then((res) => {
						if (res.data.response) {
							this.referencesForm = { ...this.referencesForm, ...res.data.response };
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		updateReferences() {
			let component = this;
			component.$v.referencesForm.$touch();
			component.isUpdatingCharacterReference = true;

			if (component.$v.referencesForm.$invalid) {
				Swal.fire({
					title: 'Error!',
					text: 'Please make sure all of the required fields are filled',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				return;
			}

			let token = localStorage.getItem('token');

			if (!token) {
				Swal.fire({
					title: 'Error!',
					text: 'Invalid login',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				return;
			}

			let config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			component.referencesForm.user_type_id = component.userTypeId;
			component.referencesForm.user_id = component.userId;
			axios
				.post('user/references', component.referencesForm, config)
				.then(async (res) => {
					component.isUpdatingCharacterReference = false;
					if (res.status != 200) {
						Swal.fire({
							title: 'Error!',
							text: 'Something went wrong :(',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
						return;
					}

					await Swal.fire({
						title: 'Success!',
						text: 'References updated successfully!',
						icon: 'success',
						width: 350,
						showConfirmButton: false,
						timer: 1500,
					});
					component.getReferences();
				})
				.catch(async (err) => {
					component.isUpdatingCharacterReference = false;
					if (err.response) {
						await Swal.fire({
							title: 'Error!',
							text: err.response.data?.error?.message || err.response.data?.message,
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
				});
		},
		fillRefrain(e) {
			if (e.target.value == 'true' || e.target.value == true) {
				this.questionForm.refrain = 'Good';
			} else {
				this.questionForm.refrain = '';
			}
		},
		fillViolation(e) {
			if (e.target.value == 'true' || e.target.value == true) {
				this.questionForm.driving_violations = 'Good';
			} else {
				this.questionForm.driving_violations = '';
			}
		},
		fillSubmittedApplication(e) {
			if (e.target.value == 'true' || e.target.value == true) {
				this.questionForm.submit_application = 'Good';
			} else {
				this.questionForm.submit_application = '';
			}
		},
		getEmployment() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('user/employments/' + this.userId + '?user_type_id=' + this.userTypeId, config)
					.then((res) => {
						if (res.status == 200) {
							this.employmentForm = res.data.response;
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		updateEmployment() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			};
			if (token) {
				this.employmentForm.user_type_id = this.userTypeId;
				this.employmentForm.user_id = this.userId;
				axios
					.post('user/employments', this.employmentForm, config)
					.then((res) => {
						if (res.status == 200) {
							this.faithForm = res.data.response;
							Swal.fire({
								title: 'Success!',
								text: 'Employment updated successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.getEmployment();
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		// Getting Current User Additional Details
		getAdditionalDetails() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('user/additional_details/' + this.userId + '?user_type_id=' + this.userTypeId, config)
					.then((res) => {
						if (res.status == 200) {
							this.additionalDetailsForm = res.data.response;
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		updateAdditionalDetails() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			};
			if (token) {
				this.additionalDetailsForm.user_type_id = this.userTypeId;
				this.additionalDetailsForm.user_id = this.userId;
				axios
					.post('user/additional_details', this.additionalDetailsForm, config)
					.then((res) => {
						if (res.status == 200) {
							this.additionalDetailsForm = res.data.response;
							Swal.fire({
								title: 'Success!',
								text: 'Additional Details updated successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.getAdditionalDetails();
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		// Getting Current User Opportunities Details
		getOpportunities() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('user/opportunities/' + this.userId + '?user_type_id=' + this.userTypeId, config)
					.then((res) => {
						if (res.status == 200) {
							this.opportunitiesForm = res.data.response;
							if (this.userTypeId == 3) {
								this.opportunitiesForm.is_mentor = true;
							} else {
								this.opportunitiesForm.is_mentor = this.isMentor;
							}
							let selectedBuildings = [];
							res.data.response.roles.map(function (value) {
								selectedBuildings.push(value.id);
							});
							this.selectedRoleIds = selectedBuildings;
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		updateOpportunities() {
			this.opportunitiesForm.role_ids = this.selectedRoleIds;
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			};
			if (token) {
				this.opportunitiesForm.user_type_id = this.userTypeId;
				axios
					.post('user/opportunities', this.opportunitiesForm, config)
					.then((res) => {
						if (res.status == 200) {
							this.opportunitiesForm = res.data.response;
							Swal.fire({
								title: 'Success!',
								text: 'Opportunities updated successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.getOpportunities();
						}
					})
					.catch((err) => {
						if (err.response) {
							this.isShow = true;
							this.errors = err.response.data.error.message;
						}
					});
			}
		},

		getCategories() {
			axios.get('categories?pagination=true&per_page=1000').then((res) => {
				this.categories = res.data.response.data;
			});
		},

		sendCharacterReference() {
			let component = this;
			if (!component.contactInfoForm.approval || !component.contactInfoForm.approval.id) {
				return;
			}
			let approvalId = component.contactInfoForm.approval.id;

			let token = localStorage.getItem('token');
			if (!token) {
				return;
			}

			let config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};

			component.isSendingCharacterReference = true;
			axios
				.get('admin/send/reference/email?user_id=' + component.referencesForm.user_id + '&user_type_id=' + component.referencesForm.user_type_id + '&approval_id=' + approvalId, config)
				.then((res) => {
					component.isSendingCharacterReference = false;
					if (res.status == 200) {
						Swal.fire({
							title: 'Success!',
							text: 'Character reference email sent successfully!',
							icon: 'success',
							width: 350,
							showConfirmButton: false,
							timer: 1500,
						});
					}
				})
				.catch((err) => {
					component.isSendingCharacterReference = false;
					if (err.response) {
						Swal.fire({
							title: 'Error!',
							text: err.response.data?.error?.message || err.response.data?.message,
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
				});
		},

		deleteCharacterReference() {
			let component = this;
			component.isDeletingCharacterReference = true;

			Swal.fire({
				title: 'Are you sure?',
				text: 'Delete this Character Reference?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#34c38f',
				cancelButtonColor: '#f46a6a',
				confirmButtonText: 'Yes!',
			}).then((result) => {
				if (result.value) {
					if (!component.userId || !component.userTypeId) {
						component.isCreatingCharacterReference = false;
						Swal.fire({
							title: 'Error!',
							text: 'User data missing',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
						return;
					}

					let token = localStorage.getItem('token');
					if (!token) {
						component.isDeletingCharacterReference = false;
						Swal.fire({
							title: 'Error!',
							text: 'Invalid login',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
						return;
					}

					let characterReferenceId = component?.referencesForm?.id || null;
					if (!characterReferenceId) {
						component.isDeletingCharacterReference = false;
						Swal.fire({
							title: 'Error!',
							text: 'Invalid character reference',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
						return;
					}

					let config = {
						headers: {
							Authorization: 'Bearer ' + token,
							Accept: 'application/json',
						},
					};
					axios
						.delete(`user/references/${characterReferenceId}`, config)
						.then(async (res) => {
							component.isDeletingCharacterReference = false;
							if (res.status != 200) {
								Swal.fire({
									title: 'Error!',
									text: 'Something went wrong :(',
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
								return;
							}

							await Swal.fire({
								title: 'Success!',
								text: 'References created successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							component.referencesForm = null;
						})
						.catch(async (err) => {
							component.isDeletingCharacterReference = false;
							if (err.response) {
								await Swal.fire({
									title: 'Error!',
									text: err.response.data?.error?.message || err.response.data?.message || 'Something went wrong :(',
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				} else {
					component.isDeletingCharacterReference = false;
				}
			});
		},

		createCharacterReference() {
			let component = this;
			component.isCreatingCharacterReference = true;
			if (!component.userId || !component.userTypeId) {
				component.isCreatingCharacterReference = false;
				Swal.fire({
					title: 'Error!',
					text: 'User data missing',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				return;
			}

			let token = localStorage.getItem('token');
			if (!token) {
				component.isCreatingCharacterReference = false;
				Swal.fire({
					title: 'Error!',
					text: 'Invalid login',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				return;
			}

			let characterReference = {};
			characterReference.user_id = component.userId;
			characterReference.user_type_id = component.userTypeId;
			characterReference.user_type = 'mentor';
			characterReference.status = '1';

			let config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			axios
				.post('user/references', characterReference, config)
				.then(async (res) => {
					component.isCreatingCharacterReference = false;
					if (res.status != 200) {
						Swal.fire({
							title: 'Error!',
							text: 'Something went wrong :(',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
						return;
					}

					await Swal.fire({
						title: 'Success!',
						text: 'References created successfully!',
						icon: 'success',
						width: 350,
						showConfirmButton: false,
						timer: 1500,
					});
					component.getReferences();
				})
				.catch(async (err) => {
					component.isCreatingCharacterReference = false;
					if (err.response) {
						await Swal.fire({
							title: 'Error!',
							text: err.response.data?.error?.message || err.response.data?.message || 'Something went wrong :(',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
				});
		},

		reGenerateReferenceToken() {
			let component = this;
			component.isRegeneratingReferenceToken = true;

			let token = localStorage.getItem('token');
			if (!token) {
				Swal.fire({
					title: 'Error!',
					text: 'Invalid login',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				return;
			}

			let config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};

			axios
				.post(`user/reference-generate-token/${component.referencesForm.id}`, config)
				.then(async (res) => {
					component.isRegeneratingReferenceToken = false;
					if (res.status != 200) {
						Swal.fire({
							title: 'Error!',
							text: 'Something went wrong :(',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
						return;
					}

					await Swal.fire({
						title: 'Success!',
						text: 'References token re-generated!',
						icon: 'success',
						width: 350,
						showConfirmButton: false,
						timer: 1500,
					});
					component.getReferences();
				})
				.catch(async (err) => {
					component.isRegeneratingReferenceToken = false;
					if (err.response) {
						await Swal.fire({
							title: 'Error!',
							text: err.response.data?.error?.message || err.response.data?.message,
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
				});
		},
	},
};
</script>

<template>
	<div role="tablist">
		<!-- Applicant History -->
		<b-card no-body class="mb-3 border shadow-none">
			<b-card-header header-tag="header" role="tab">
				<h6 class="m-0">
					<a v-b-toggle.applicationQuestions class="text-dark font-size-16" href="javascript: void(0);">Applicant History <i class="font-size-20 float-end bx bxs-plus-circle"></i></a>
				</h6>
			</b-card-header>

			<b-collapse id="applicationQuestions" accordion="my-accordion" role="tabpanel">
				<b-card-body>
					<form>
						<div class="mb-4">
							<div class="d-flex align-items-baseline">
								<label>
									<!-- Have you submitted an application here before? -->
									Have you submitted an application to mentor or volunteer at MnTC before?
								</label>
								<div class="form-check mb-3">
									<input v-model="beforeSubmittedApplication" @change="fillSubmittedApplication($event)" class="form-check-input ms-1" type="radio" id="beforeSubmittedApplication" name="beforeSubmittedApplication" :value="true" />
									<label class="form-check-label ms-1" for="beforeSubmittedApplication"> Yes </label>
								</div>

								<div class="form-check mb-3">
									<input v-model="beforeSubmittedApplication" @change="fillSubmittedApplication($event)" class="form-check-input ms-1" type="radio" id="beforeSubmittedApplicationNo" name="beforeSubmittedApplication" :value="false" />
									<label class="form-check-label ms-1" for="beforeSubmittedApplicationNo"> no </label>
								</div>
							</div>
							<input v-model="questionForm.submit_application" type="hidden" class="mt-2 form-control" />
						</div>

						<div class="mb-4">
							<div class="d-flex align-items-baseline">
								<label>Have you been convicted of a criminal offense (not including traffic violations).</label>
								<div class="form-check mb-3">
									<input v-model="convictedCriminal" class="form-check-input ms-1" type="radio" :value="true" id="convictedCriminal" />
									<label class="form-check-label ms-1" for="convictedCriminal"> Yes </label>
								</div>

								<div class="form-check mb-3">
									<input v-model="convictedCriminal" class="form-check-input ms-1" type="radio" :value="false" id="convictedCriminalNo" />
									<label class="form-check-label ms-1" for="convictedCriminalNo"> no </label>
								</div>
							</div>
							<input v-model="questionForm.convicted" type="text" class="mt-2 form-control" />
						</div>

						<div class="mb-4">
							<div class="d-flex align-items-baseline">
								<label>Have you sought treatment for substance use disorders?.</label>
								<div class="form-check mb-3">
									<input v-model="drugPrescription" class="form-check-input ms-1" type="radio" :value="true" id="drugPrescription" />
									<label class="form-check-label ms-1" for="drugPrescription"> Yes </label>
								</div>
								<div class="form-check mb-3">
									<input v-model="drugPrescription" class="form-check-input ms-1" type="radio" :value="false" id="drugPrescriptionNo" />
									<label class="form-check-label ms-1" for="drugPrescriptionNo"> no </label>
								</div>
							</div>
							<input v-model="questionForm.treatment" type="text" class="mt-2 form-control" />
						</div>

						<div class="mb-4">
							<div class="d-flex align-items-baseline">
								<label>Have you been arrested for an offense involving substance use disorders?</label>
								<div class="form-check mb-3">
									<input v-model="involveInAlcohol" class="form-check-input ms-1" type="radio" :value="true" id="involveInAlcohol" />
									<label class="form-check-label ms-1" for="involveInAlcohol"> Yes </label>
								</div>
								<div class="form-check mb-3">
									<input v-model="involveInAlcohol" class="form-check-input ms-1" type="radio" :value="false" id="involveInAlcoholNo" />
									<label class="form-check-label ms-1" for="involveInAlcoholNo"> no </label>
								</div>
							</div>
							<input type="text" v-model="questionForm.arrested" class="mt-2 form-control" />
						</div>

						<div class="mb-4">
							<div class="d-flex align-items-baseline">
								<label>Have you used illegal drugs, abused prescription drugs, or abused alcohol within the past two years?</label>
								<div class="form-check mb-3">
									<input v-model="drivingViolations" @change="fillViolation($event)" class="form-check-input ms-1" type="radio" :value="true" id="drivingViolations" />
									<label class="form-check-label ms-1" for="drivingViolations"> Yes </label>
								</div>
								<div class="form-check mb-3">
									<input v-model="drivingViolations" @change="fillViolation($event)" class="form-check-input ms-1" type="radio" :value="false" id="drivingViolationsNo" />
									<label class="form-check-label ms-1" for="drivingViolationsNo"> no </label>
								</div>
							</div>
						</div>

						<div class="mb-4">
							<div class="d-flex align-items-baseline">
								<label>Do you use tobacco products (cigarettes, e-cigarettes/vapes, chewing tobacco, etc.) or live with someone who does?</label>
								<div class="form-check mb-3">
									<input v-model="refrainTobacco" @change="fillRefrain($event)" class="form-check-input ms-1" type="radio" :value="true" id="refrainTobacco" />
									<label class="form-check-label ms-1" for="refrainTobacco"> Yes </label>
								</div>
								<div class="form-check mb-3">
									<input v-model="refrainTobacco" @change="fillRefrain($event)" class="form-check-input ms-1" type="radio" :value="false" id="refrainTobaccoNo" />
									<label class="form-check-label ms-1" for="refrainTobaccoNo"> No </label>
								</div>
							</div>
						</div>
						<div class="mb-2 mt-3">
							<b-button @click="updateQuestion" variant="primary">Update Question</b-button>
						</div>
					</form>
				</b-card-body>
			</b-collapse>
		</b-card>

		<!-- Background Check Information -->
		<b-card v-if="userTypeId !== 4 || (userTypeId == 4 && contactInfoForm.is_upgraded == true)" no-body class="mb-3 border shadow-none">
			<b-card-header header-tag="header" role="tab">
				<h6 class="m-0">
					<a v-b-toggle.socialSecurity class="text-dark font-size-16" href="javascript: void(0);">Background Check Information <i class="font-size-20 float-end bx bxs-plus-circle"></i></a>
				</h6>
			</b-card-header>

			<b-collapse id="socialSecurity" accordion="my-accordion" role="tabpanel">
				<b-card-body>
					<form>
						<div class="row">
							<div class="col-4">
								<div class="mb-3">
									<label>SSN</label>
									<b-input-group>
										<b-form-input v-model="backgroundCheckForm.ssn" :type="showSSN ? 'text' : 'password'" placeholder="XXXX" class="formcontrol"></b-form-input>
										<b-input-group-append>
											<button class="btn btn-outline-light rounded-0 rounded-right" style="border-color: #ced4da" type="button" @click="showSSN = !showSSN">
												<i class="mdi" :class="{ 'mdi-eye-off': showSSN, 'mdi-eye': !showSSN }"></i>
											</button>
										</b-input-group-append>
									</b-input-group>
								</div>
								<div class="form-check mb-3">
									<input v-model="backgroundCheckForm.ssn_remove" class="form-check-input" type="checkbox" value="" id="ssnRemove" />
									<label class="form-check-label" for="ssnRemove"> Remove SSN </label>
								</div>
							</div>

							<div class="col-4">
								<div class="mb-3">
									<label>Driver's License Number</label>
									<input v-model="backgroundCheckForm.driver_license_number" type="text" placeholder="XXXXXXXXXXXXXXXX" class="form-control" />
								</div>
								<div class="form-check mb-3">
									<input v-model="backgroundCheckForm.driver_license_number_remove" class="form-check-input" type="checkbox" value="" id="licenseRemove" />
									<label class="form-check-label" for="licenseRemove"> Remove Driver's License Number </label>
								</div>
							</div>

							<div class="col-4">
								<div class="mb-3">
									<label>Driver’s License State</label>
									<input v-model="backgroundCheckForm.driver_license_state" type="text" class="form-control" />
								</div>
							</div>
						</div>

						<div class="col-12 inner-repeater mb-4">
							<h2 class="font-size-14 fw-bold mt-3 mb-2">Previous Residence(s)</h2>
							<div class="inner mb-3 row">
								<div v-for="(data, index) in backgroundCheckForm.previous_residence" :key="index" class="inner mb-3 row">
									<div class="col-5">
										<input v-model="data.previous_state" type="text" name="previous_state" class="inner form-control" placeholder="Enter Previous Address State" />
									</div>

									<div class="col-6">
										<input v-model="data.previous_city" type="text" name="previous_city" class="inner form-control" placeholder="Enter Previous Address City" />
									</div>

									<div class="col-1">
										<div class="d-grid">
											<button type="button" @click="deleteResidence(index)" class="btn font-size-16">
												<i class="font-size-20 text-danger bx bxs-trash"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<button type="button" title="Add Residence" @click="addResidence" class="d-flex py-0 px-0 btn">
								<i class="font-size-24 me-1 text-primary bx bxs-plus-circle"></i>
								Add Residence
							</button>
						</div>

						<div class="mb-3">
							<label>Description</label>
							<div>
								<textarea v-model="backgroundCheckForm.description" class="form-control" rows="3" placeholder="Enter Description"></textarea>
							</div>
						</div>

						<div class="row">
							<div class="col-6">
								<div class="mb-3">
									<label class="mt-0">Signature Provided</label>

									<b-form-select class="form-select" v-model="backgroundCheckForm.signature_provided" :options="signatureOptions">
										<option slot="first" :value="null" disabled>Select Status</option>
									</b-form-select>
								</div>
							</div>

							<div class="col-6">
								<div class="mb-3">
									<label>Date Signed</label>
									<br />
									<b-form-input v-model="backgroundCheckForm.date_signed" type="date"></b-form-input>
								</div>
							</div>

							<div class="mb-2 mt-3">
								<b-button @click="updateBackgroundDetails" variant="primary">Update Background Details</b-button>
							</div>
						</div>
					</form>
				</b-card-body>
			</b-collapse>
		</b-card>

		<!-- Faith Journey -->
		<b-card no-body class="mb-3 border shadow-none">
			<b-card-header header-tag="header" role="tab">
				<h6 class="m-0">
					<a v-b-toggle.faith class="text-dark font-size-16" href="javascript: void(0);">Faith Journey <i class="font-size-20 float-end bx bxs-plus-circle"></i></a>
				</h6>
			</b-card-header>

			<b-collapse id="faith" accordion="my-accordion" role="tabpanel">
				<b-card-body>
					<form>
						<div class="row">
							<div class="col-12 mb-5">
								<label class="form-check-label me-2">Attended Place of Worship?</label>
								<b-form-radio v-model="faithForm.attend_worship" value="1" class="d-inline-block">Yes</b-form-radio>
								<b-form-radio v-model="faithForm.attend_worship" class="d-inline-block ms-4" value="0">No</b-form-radio>
							</div>
							<div class="col-12 col-md-4 mb-5">
								<input v-model="faithForm.location" type="text" placeholder="Enter Location" class="form-control" name="location_name" />
							</div>
							<div class="col-12 col-md-4 mb-5">
								<input v-model="faithForm.city" type="text" placeholder="Enter City" class="form-control" name="city" />
							</div>
							<div class="col-12 col-md-4 mb-5">
								<input v-model="faithForm.state" type="text" placeholder="Enter State" class="form-control" name="state" />
							</div>
							<div class="col-12 col-md-6 mb-5">
								<label>
									Please list any areas of involvement and/or service
									<!-- Faith Involvement -->
								</label>
								<textarea v-model="faithForm.faith_involvement" class="form-control" name="faith_involvement" rows="3" placeholder="Enter Faith Involvement"></textarea>
							</div>
							<div class="col-12 col-md-6 mb-5">
								<label>
									<!-- Faith Journey -->
									Please describe your personal faith journey: (500 words or less)
								</label>
								<textarea v-model="faithForm.faith_journey" class="form-control" name="faith_journey" rows="3" placeholder="Enter Faith Journey"></textarea>
							</div>
						</div>

						<div class="mb-2 mt-3">
							<b-button @click="updateFaith" variant="primary">Update Faith</b-button>
						</div>
					</form>
				</b-card-body>
			</b-collapse>
		</b-card>

		<!-- Character Reference -->
		<b-card no-body class="mb-3 border shadow-none">
			<b-card-header header-tag="header" role="tab">
				<h6 class="m-0">
					<a v-b-toggle.references class="text-dark font-size-16" href="javascript: void(0);">Character Reference <i class="font-size-20 float-end bx bxs-plus-circle"></i></a>
				</h6>
			</b-card-header>

			<b-collapse id="references" accordion="my-accordion" role="tabpanel">
				<b-card-body v-if="referencesForm && referencesForm.id">
					<div class="row">
						<div class="col-6">
							<h4 class="font-size-14 fw-bold">Reference</h4>
						</div>
						<div class="col-6">
							<div class="d-flex justify-content-end">
								<b-button @click="sendCharacterReference" variant="outline-primary" :disabled="isSendingCharacterReference" v-if="referencesForm && referencesForm.id">Send Character Reference</b-button>
								<b-button @click="deleteCharacterReference" variant="outline-danger" :disabled="isDeletingCharacterReference" class="ms-2">Delete</b-button>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<div class="mb-3">
								<label class="mt-0">Select Status <span style="color: red">(Required)</span></label>
								<b-form-select class="form-select" v-model="referencesForm.status" :options="status" :class="{ 'is-invalid': isUpdatingCharacterReference && $v.referencesForm.status.$error }">
									<option slot="first" :value="null" disabled>Select Status</option>
								</b-form-select>
								<div v-if="isUpdatingCharacterReference && $v.referencesForm.status.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.status.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Your First and Last Name <span style="color: red">(Required)</span></label>
								<input v-model="referencesForm.name" type="text" placeholder="Enter Name" class="form-control" :class="{ 'is-invalid': isUpdatingCharacterReference && $v.referencesForm.name.$error }" />
								<div v-if="isUpdatingCharacterReference && $v.referencesForm.name.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.name.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Your Email <span style="color: red">(Required)</span></label>
								<input v-model="referencesForm.email" type="text" placeholder="Enter Email" class="form-control" :class="{ 'is-invalid': isUpdatingCharacterReference && $v.referencesForm.email.$error }" />
								<div v-if="isUpdatingCharacterReference && $v.referencesForm.email.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.email.required">This field is required</span>
									<span v-if="!$v.referencesForm.email.email">Please provide a valid email</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Your Phone Number</label>
								<input v-model="referencesForm.telephone" type="text" placeholder="Enter Telephone" class="form-control" :class="{ 'is-invalid': isUpdatingCharacterReference && $v.referencesForm.telephone.$error }" />
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Relationship</label>
								<input v-model="referencesForm.relationship" type="text" placeholder="Enter Relationship" class="form-control" />
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Input Form Token <span style="color: red">(Required)</span></label>
								<b-input-group :class="{ 'is-invalid': isUpdatingCharacterReference && $v.referencesForm.token.$error }">
									<input v-model="referencesForm.token" type="text" placeholder="Enter Input Form Token" class="form-control" disabled readonly :class="{ 'is-invalid': isUpdatingCharacterReference && $v.referencesForm.token.$error }" />
									<b-input-group-append>
										<button class="btn btn-outline-light rounded-0 rounded-right" style="border-color: #ced4da" type="button" @click="reGenerateReferenceToken" :disabled="isRegeneratingReferenceToken"><i class="mdi mdi-cached"></i></button>
									</b-input-group-append>
								</b-input-group>
								<div v-if="isUpdatingCharacterReference && $v.referencesForm.token.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.token.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Your Organization</label>
								<input v-model="referencesForm.organization" type="text" placeholder="Enter Organization" class="form-control" />
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Your Title</label>
								<input v-model="referencesForm.title" type="text" placeholder="Enter Title" class="form-control" />
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Date Signed</label>
								<br />
								<input v-model="referencesForm.date" type="date" class="form-control" />
							</div>
						</div>

						<div class="mb-3">
							<label class="form-check-label me-4"> How long have you known the applicant? </label>
							<b-form-radio v-model="referencesForm.year_applicant" value="lessthenyear" class="d-inline-block">Less than a Year </b-form-radio>
							<b-form-radio v-model="referencesForm.year_applicant" class="d-inline-block ms-4" value="onetothree">1 to 3</b-form-radio>
							<b-form-radio v-model="referencesForm.year_applicant" class="d-inline-block ms-4" value="threetofive">3 to 5</b-form-radio>
							<b-form-radio v-model="referencesForm.year_applicant" class="d-inline-block ms-4" value="fivetoten">5 to 10</b-form-radio>
							<b-form-radio v-model="referencesForm.year_applicant" class="d-inline-block ms-4" value="tenplus">10+</b-form-radio>
						</div>

						<div class="mb-3">
							<label>How do you know the applicant? *</label>
							<div>
								<textarea v-model="referencesForm.applicant" class="form-control" rows="3" placeholder="Write Here.."></textarea>
							</div>
						</div>

						<div class="mb-3">
							<label>What are the applicant's strengths in regard to mentoring? *</label>
							<div>
								<textarea v-model="referencesForm.strenths" class="form-control" rows="3" placeholder="Write Here.."></textarea>
							</div>
						</div>

						<div class="mb-3">
							<label>What are the applicant's growth areas in regard to mentoring?</label>
							<div>
								<textarea v-model="referencesForm.weaknesses" class="form-control" rows="3" placeholder="Write Here.."></textarea>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-10">
								<label>In your opinion, is the applicant suitable for working with vulnerable adults?</label>
							</div>
							<div class="col-2">
								<b-form-select class="form-select ms-3" v-model="referencesForm.adults_adolescents" :options="options">
									<option slot="first" :value="null" disabled>Select Option</option>
								</b-form-select>
							</div>
						</div>

						<div class="mb-3" v-if="referencesForm.adults_adolescents === 'unsure'">
							<label>please provide explanation:</label>
							<div>
								<textarea v-model="referencesForm.adults_adolescents_text" class="form-control" rows="3" placeholder="Write Here.."></textarea>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-10">
								<label> In your opinion, can the applicant maintain healthy boundaries with clients? </label>
							</div>
							<div class="col-2">
								<b-form-select class="form-select ms-3" v-model="referencesForm.professional_boundaries" :options="options">
									<option slot="first" :value="null" disabled>Select Option</option>
								</b-form-select>
							</div>
						</div>

						<div class="mb-3" v-if="referencesForm.professional_boundaries === 'unsure'">
							<label>please provide explanation:</label>
							<div>
								<textarea v-model="referencesForm.professional_boundaries_text" class="form-control" rows="3" placeholder="Write Here.."></textarea>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-10">
								<label> In your opinion, does the applicant have the spiritual maturity needed to effectively model a Christian lifestyle? </label>
							</div>
							<div class="col-2">
								<b-form-select class="form-select ms-3" v-model="referencesForm.spiritual_maturity" :options="options">
									<option slot="first" :value="null" disabled>Select Option</option>
								</b-form-select>
							</div>
						</div>

						<div class="mb-3" v-if="referencesForm.spiritual_maturity === 'unsure'">
							<label>please provide explanation:</label>
							<div>
								<textarea v-model="referencesForm.spiritual_maturity_text" class="form-control" rows="3" placeholder="Write Here.."></textarea>
							</div>
						</div>

						<!-- ratings questions -->
						<div class="mb-3 row">
							<div class="col-3">
								<label class="mb-3">
									<!-- Cooperation : -->
									The applicant is a good communicator:
								</label>
							</div>

							<div class="col-9">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" v-model="referencesForm.cooperation" name="cooperation" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="cooperation" v-model="referencesForm.cooperation" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="cooperation" v-model="referencesForm.cooperation" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="cooperation" v-model="referencesForm.cooperation" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="cooperation" v-model="referencesForm.cooperation" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-3">
								<label class="mb-3">
									<!-- congruent : -->
									The applicant’s words and <br />
									actions are congruent:
								</label>
							</div>

							<div class="col-9">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" v-model="referencesForm.congruent" name="congruent" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="congruent" v-model="referencesForm.congruent" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="congruent" v-model="referencesForm.congruent" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="congruent" v-model="referencesForm.congruent" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="congruent" v-model="referencesForm.congruent" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-3">
								<label class="mb-3">
									<!-- Initiative : -->
									The applicant takes initiative when action is needed:
								</label>
							</div>

							<div class="col-9">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-3">
								<label class="mb-3">
									<!-- Reliability : -->
									The applicant is honest and trustworthy:
								</label>
							</div>

							<div class="col-9">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-3">
								<label class="mb-3">
									<!-- Maturity : -->
									The applicant handles difficult situations with maturity:
								</label>
							</div>

							<div class="col-9">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-3">
								<label class="mb-3">
									<!-- Leadership : -->
									The applicant generally follows through on commitments:
								</label>
							</div>

							<div class="col-9">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-3">
								<label class="mb-3">
									<!-- Good Listener : -->
									The applicant is a good listener:
								</label>
							</div>

							<div class="col-9">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-1" v-model="referencesForm.listener" value="1" />
									<label class="form-check-label" for="good-listener-1">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-2" v-model="referencesForm.listener" value="2" />
									<label class="form-check-label" for="good-listener-2">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-3" v-model="referencesForm.listener" value="3" />
									<label class="form-check-label" for="good-listener-3">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-4" v-model="referencesForm.listener" value="4" />
									<label class="form-check-label" for="good-listener-4">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-5" v-model="referencesForm.listener" value="5" />
									<label class="form-check-label" for="good-listener-5">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-3">
								<label class="mb-3">
									<!-- Overall Recommendation : -->
									Overall recommendation of the applicant as a MnTC mentor:
								</label>
							</div>

							<div class="col-9">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-1" v-model="referencesForm.recommendation" value="1" />
									<label class="form-check-label" for="recommendation-1">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-2" v-model="referencesForm.recommendation" value="2" />
									<label class="form-check-label" for="recommendation-2">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-3" v-model="referencesForm.recommendation" value="3" />
									<label class="form-check-label" for="recommendation-3">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-4" v-model="referencesForm.recommendation" value="4" />
									<label class="form-check-label" for="recommendation-4">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-5" v-model="referencesForm.recommendation" value="5" />
									<label class="form-check-label" for="recommendation-5">5</label>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-12">
							<div class="mb-2 mt-3">
								<b-button @click="updateReferences" variant="primary">Update Reference</b-button>
							</div>
						</div>
					</div>
				</b-card-body>
				<b-card-body v-else>
					<div class="row">
						<div class="col-12">
							<b-button @click="createCharacterReference" variant="outline-primary" :disabled="isCreatingCharacterReference">Create Character Reference</b-button>
						</div>
					</div>
				</b-card-body>
			</b-collapse>
		</b-card>

		<!-- Interest, Skills, Involvement -->
		<b-card no-body class="mb-3 border shadow-none">
			<b-card-header header-tag="header" role="tab">
				<h6 class="m-0">
					<a v-b-toggle.additionalInformation class="text-dark font-size-16" href="javascript: void(0);">Interest, Skills, Involvement <i class="font-size-20 float-end bx bxs-plus-circle"></i></a>
				</h6>
			</b-card-header>

			<b-collapse id="additionalInformation" accordion="my-accordion" role="tabpanel">
				<b-card-body>
					<form>
						<div class="mb-3">
							<label>When and how did you first hear about MnTC?</label>
							<input v-model="additionalDetailsForm.hear_about" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-3">
							<label>Why do you think you would make a good volunteer at MnTC?</label>
							<input v-model="additionalDetailsForm.adult_teen_challenge" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-3">
							<label>What are your Hobbies, Interests and Passions?</label>
							<input v-model="additionalDetailsForm.hobbies" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-3">
							<label>Do you have any trade skills?</label>
							<input v-model="additionalDetailsForm.skills" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-3">
							<label>Do you speak a foreign language(s)?</label>
							<input v-model="additionalDetailsForm.language" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-3">
							<label>What is your educational background (degrees, field(s) of study, etc.)?</label>
							<input v-model="additionalDetailsForm.education" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-3">
							<label>What is your current occupation?</label>
							<input v-model="additionalDetailsForm.occupation" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-3">
							<label>Where are you currently employed?</label>
							<input v-model="additionalDetailsForm.employment_experience" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-3">
							<label>What is the city and state where you work?</label>
							<input v-model="additionalDetailsForm.working_city" type="text" placeholder="Write here.." class="form-control" />
						</div>
						<div class="mb-3">
							<label>Is there any additional information you would like to share? (ie: previous employment, skills, certificates, credentials, etc.)</label>
							<input v-model="additionalDetailsForm.additional_info" type="text" placeholder="Write here.." class="form-control" />
						</div>

						<div class="mb-2 mt-3">
							<b-button @click="updateAdditionalDetails" variant="primary">Update Additional Details</b-button>
						</div>
					</form>
				</b-card-body>
			</b-collapse>
		</b-card>

		<!-- Opportunities -->
		<b-card no-body class="mb-3 border shadow-none">
			<b-card-header header-tag="header" role="tab">
				<h6 class="m-0">
					<a v-b-toggle.opportunities class="text-dark font-size-16" href="javascript: void(0);">Opportunities <i class="font-size-20 float-end bx bxs-plus-circle"></i></a>
				</h6>
			</b-card-header>

			<b-collapse id="opportunities" accordion="my-accordion" role="tabpanel">
				<b-card-body>
					<form>
						<div class="row">
							<div class="col-12">
								<h4 class="font-size-16 mb-4">Mentor</h4>

								<div class="form-check mb-3">
									<input v-model="opportunitiesForm.is_mentor" class="form-check-input" type="checkbox" :value="true" id="becomeMentor" :disabled="true" />
									<label class="form-check-label" for="becomeMentor"> Become A Mentor </label>
								</div>
							</div>

							<div class="col-12">
								<h4 class="font-size-16 mb-4">Volunteer</h4>

								<div class="row">
									<div class="col-3" v-for="(category, categoryIndex) in categories" :key="categoryIndex">
										<div class="form-check mb-3">
											<label class="ms-n4 d-block fw-bold">{{ category.name }}</label>
											<div v-for="(role, roleIndex) in category.roles" :key="roleIndex">
												<input v-bind:key="roleIndex" v-model="selectedRoleIds" class="form-check-input" type="checkbox" true-value="1" false-value="0" :id="role.id" :value="role.id" />
												<label class="form-check-label" :for="role.id"> {{ role.name }} </label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<label>Comments </label>
							<div>
								<textarea v-model="opportunitiesForm.comment" class="form-control" rows="3" placeholder="Write Here.."></textarea>
							</div>
						</div>

						<div class="mb-2 mt-3">
							<b-button @click="updateOpportunities" variant="primary">Update Opportunities</b-button>
						</div>
					</form>
				</b-card-body>
			</b-collapse>
		</b-card>
	</div>
</template>
<style scoped>
.roles-boxes .box {
	width: calc(92% / 2 - 0px);
	margin-right: 2%;
	margin-top: 2%;
	float: left;
}

.box {
	padding: 5px;
	text-align: center;
}

.box.mentor {
	border: 2px solid #556ee6;
}

.box.donor {
	border: 2px solid #34c38f;
}

.box.p-alum {
	border: 2px solid #50a5f1;
}

.box.volunteer {
	border: 2px solid #f1b44c;
}

.chck-icon {
	font-size: 130px;
}

.pb-1-5rem {
	padding-bottom: 1.5rem !important;
}
</style>
